import UserApi from 'common/api/UserApi';

const api = new UserApi();

export const REQUEST_SERVICE_LIMITS = 'REQUEST_SERVICE_LIMITS';

export function requestServiceLimits(serviceId) {
  return {type: REQUEST_SERVICE_LIMITS, serviceId};
}

export const RECEIVE_SERVICE_LIMITS = 'RECEIVE_SERVICE_LIMITS';

export function receiveServiceLimits(serviceId, limits) {
  return {type: RECEIVE_SERVICE_LIMITS, serviceId, limits};
}

export const RECEIVE_SERVICE_LIMITS_ERROR = 'RECEIVE_SERVICE_LIMITS_ERROR';

export function receiveServiceLimitsError(serviceId) {
  return {type: RECEIVE_SERVICE_LIMITS_ERROR, serviceId};
}

// Fetch the logged-in rider's configured limits + current usage for a service. timestamp is
// optional and anchors the usage window (the endpoint defaults to now when it is omitted).
export function fetchServiceLimits(serviceId, timestamp) {
  return (dispatch) => {
    dispatch(requestServiceLimits(serviceId));
    return api.fetchRiderServiceLimits({serviceId, timestamp}).then((response) => {
      if (response.status === 200) {
        return response.json().then((limits) =>
          dispatch(receiveServiceLimits(serviceId, limits)));
      }
      return dispatch(receiveServiceLimitsError(serviceId));
    });
  };
}



// WEBPACK FOOTER //
// ./src/ondemand/actions/serviceLimits.js